import store from '@/store';
import axios, { AxiosInstance } from 'axios';

const axiosHelper = {
	_url: process.env.VUE_APP_API_HOST_URI,
	_timeoutMs: 10000,

	parseJwt(jwt: string) : any {
		const tokenChunks = jwt.split('.');
		const tokenPayload = JSON.parse(atob(tokenChunks[1]));
		return tokenPayload;
	},
	
	async renewJwtIfExpiring() {
		await store.dispatch('exchangeRefreshTokenForJwt');
	},

	createInstance(jwt?: string): AxiosInstance {

		let instance: AxiosInstance;

		if (jwt && jwt.length > 1) {

			instance = axios.create({
				baseURL: this._url,
				timeout: this._timeoutMs,
				headers: {
					Authorization: `Bearer ${jwt}`
				}			
			});
			
			instance.interceptors.request.use(async (config) => {
				const jwtObject = this.parseJwt(jwt);				
				const issuedAt = jwtObject.iat;
				const expireAt = jwtObject.exp;
				const tokenLifetime = expireAt - issuedAt;
				const remainingLifetime = expireAt - ((new Date().getTime() / 1000) | 0);
				console.log('10 percents of lifetime', (tokenLifetime * 0.1) | 0);
				console.log('JWT remaining lifetime', remainingLifetime);				
				const isLessThan10PercentRemain = (tokenLifetime * 0.1) >= remainingLifetime;
				if (isLessThan10PercentRemain) {
					await this.renewJwtIfExpiring();
					config.headers.Authorization = `Bearer ${store.getters.jwt}`;
				}
				return config;
			});

		} else {
			instance = axios.create({
				baseURL: this._url,
				timeout: this._timeoutMs,			
			});
		}

		return instance;
	}
}



export default axiosHelper;